import barba from '@barba/core';

let pageHeader = $('.page-header--home');

$('.scroll-down').on('click', function (event) {
    event.preventDefault();

    const scrollAmount = pageHeader.outerHeight();

    $('html, body').animate({
        scrollTop: scrollAmount,
    }, 1000);
});

barba.hooks.after(() => {
    $('.scroll-down').on('click', function (event) {
        event.preventDefault();

        const scrollAmount = pageHeader.outerHeight();

        $('html, body').animate({
            scrollTop: scrollAmount,
        }, 1000);
    });
});
